import Wrapper from './wrapper';
import {
  IGroundTruthCreateParams,
  IGroundTruthListParams,
  IGroundTruthUpdateParams,
  IWrapper,
} from './types';

class GroundTruth {
  wrapper: IWrapper;
  /**
   * @param {Wrapper} wrapper
   */
  constructor(wrapper: Wrapper) {
    this.wrapper = wrapper;
  }

  /**
   * Creates a new ground truth in your data pool
   * @param {Object} data
   * @returns {Promise}
   */
  create(data: IGroundTruthCreateParams) {
    return this.wrapper.createGroundTruth(data);
  }

  /**
   * Gets a paginated list of ground truths that belong to your data pool
   * @param {[Object]} params - Search parameters
   * @returns {Promise}
   */
  list(params: IGroundTruthListParams) {
    return this.wrapper.listGroundTruths(params);
  }

  /**
   * Gets a single ground truth object
   * @param {string} id
   * @returns {Promise}
   */
  retrieve(id: string) {
    return this.wrapper.retrieveGroundTruth(id);
  }

  /**
   * Updates a ground truth
   * @param {string} id
   * @param {Object} data
   * @returns {Promise}
   */
  update(id: string, data: IGroundTruthUpdateParams) {
    return this.wrapper.updateGroundTruth(id, data);
  }

  /**
   * Permanently removes a ground truth from your data pool.
   * @param {string} id
   * @returns {Promise}
   */
  del(id: string) {
    return this.wrapper.removeGroundTruth(id);
  }
}

export default GroundTruth;
